__turbopack_context__.v({
  "content": "o_iE-G_content",
  "deliveryMethodWrapper": "o_iE-G_deliveryMethodWrapper",
  "imageContainer": "o_iE-G_imageContainer",
  "loaderSlotWrapper": "o_iE-G_loaderSlotWrapper",
  "questionMarkButton": "o_iE-G_questionMarkButton",
  "slot": "o_iE-G_slot",
  "slots": "o_iE-G_slots",
  "tooltipWrapper": "o_iE-G_tooltipWrapper",
});
